"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _util = require("@/utils/util");
var Api = _interopRequireWildcard(require("@/api/page"));
var _components = require("@/components");
var _modules = require("./modules");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    SelectImage: _components.SelectImage,
    draggable: _vuedraggable.default,
    Components: _modules.Components,
    Phone: _modules.Phone,
    Editor: _modules.Editor
  },
  data: function data() {
    return {
      // loading状态
      isLoading: false,
      // 页面装修默认数据
      defaultData: {},
      // 当前页面数据
      data: {
        page: {},
        items: []
      },
      // 当前选中的元素索引
      selectedIndex: 'page',
      // 当前选中的元素
      curItem: {},
      // 左侧正在拖拽新增的组件类型
      draggingNewType: '',
      // 当前页面ID
      pageId: null
    };
  },
  // 初始化数据
  created: function created() {
    // 记录页面ID
    this.pageId = this.$route.query.pageId;
    if (!this.pageId) {
      this.$message.warning('缺少页面ID，已返回装修列表');
      this.$router.replace('/content/pageManager');
      return;
    }
    // 获取初始化数据
    this.initData();
  },
  methods: {
    // 获取初始化数据
    initData: function initData() {
      var _this = this;
      this.isLoading = true;
      Promise.all([
      // 获取默认数据
      this.getDefaultData(),
      // 获取当前页面数据
      this.getPageData()]).then(function () {
        _this.isLoading = false;
      });
    },
    // 获取默认数据
    getDefaultData: function getDefaultData() {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        Api.defaultData().then(function (result) {
          _this2.defaultData = result.data;
          resolve();
        });
      });
    },
    // 获取当前页面数据
    getPageData: function getPageData() {
      var _this3 = this;
      var pageId = this.pageId;
      return new Promise(function (resolve, reject) {
        Api.detail({
          pageId: pageId
        }).then(function (result) {
          var pageData = result.data.detail.page_data || {
            page: {},
            items: []
          };
          if (!pageData.page) {
            pageData.page = {};
          }
          if (!pageData.page.style) {
            pageData.page.style = {
              titleTextColor: 'black',
              titleBackgroundColor: '#ffffff',
              backgroundColor: '#ffffff'
            };
          }
          if (!pageData.page.params) {
            pageData.page.params = {
              name: '页面名称',
              title: '页面标题',
              shareTitle: '分享标题'
            };
          }
          if (!Array.isArray(pageData.items)) {
            pageData.items = [];
          }
          _this3.data = pageData;
          resolve();
        });
      });
    },
    /**
     * 新增Diy组件
     * @param type
     */
    onAddItem: function onAddItem(type) {
      // 验证新增Diy组件
      if (!this.onCheckAddItem(type)) {
        return false;
      }
      var data = this.data;
      var newItem = this.buildNewItemByType(type);
      if (!newItem) {
        return false;
      }
      data.items.push(newItem);
      this.onEditer(data.items.length - 1);
    },
    buildNewItemByType: function buildNewItemByType(type) {
      var defaultData = this.defaultData;
      if (!defaultData.items || !defaultData.items[type]) {
        this.$message.error("\u7EC4\u4EF6\u9ED8\u8BA4\u914D\u7F6E\u7F3A\u5931: ".concat(type));
        return null;
      }
      return this.normalizeNewItem(_lodash.default.cloneDeep(defaultData.items[type]));
    },
    normalizeNewItem: function normalizeNewItem(item) {
      if (!item || !item.type) return item;
      var placeholder = '/assets/store/img/diy/banner/01.png';
      if (item.type === 'banner') {
        if (!Array.isArray(item.data) || item.data.length < 2) {
          item.data = [{
            imgUrl: placeholder,
            link: null
          }, {
            imgUrl: placeholder,
            link: null
          }];
        }
        item.data = item.data.map(function (row) {
          return _objectSpread(_objectSpread({}, row), {}, {
            imgUrl: row.imgUrl || placeholder
          });
        });
      }
      if (item.type === 'image') {
        if (!Array.isArray(item.data) || item.data.length < 1) {
          item.data = [{
            imgUrl: placeholder,
            imgName: 'image-1.jpg',
            link: null
          }];
        }
        item.data = item.data.map(function (row, idx) {
          return _objectSpread(_objectSpread({}, row), {}, {
            imgUrl: row.imgUrl || placeholder,
            imgName: row.imgName || "image-".concat(idx + 1, ".jpg")
          });
        });
      }
      if (item.type === 'window') {
        var windowDefaults = ['/assets/store/img/diy/window/01.jpg', '/assets/store/img/diy/window/02.jpg', '/assets/store/img/diy/window/03.jpg', '/assets/store/img/diy/window/04.jpg'];
        if (!Array.isArray(item.data) || item.data.length < 1) {
          item.data = windowDefaults.map(function (url) {
            return {
              imgUrl: url,
              link: null
            };
          });
        }
        item.data = item.data.map(function (row, idx) {
          return _objectSpread(_objectSpread({}, row), {}, {
            imgUrl: row.imgUrl || windowDefaults[idx % 4]
          });
        });
      }
      return item;
    },
    insertNewItem: function insertNewItem(type, index) {
      if (!this.onCheckAddItem(type)) {
        return false;
      }
      var data = this.data;
      var newItem = this.buildNewItemByType(type);
      if (!newItem) return false;
      var insertIndex = Math.max(0, Math.min(index, data.items.length));
      data.items.splice(insertIndex, 0, newItem);
      this.onEditer(insertIndex);
      return true;
    },
    onDropNewItem: function onDropNewItem(_ref) {
      var type = _ref.type,
        index = _ref.index;
      this.insertNewItem(type, index);
      this.draggingNewType = '';
    },
    onCopyItem: function onCopyItem(index) {
      var data = this.data;
      if (!Array.isArray(data.items) || !data.items[index]) return;
      var copyItem = _lodash.default.cloneDeep(data.items[index]);
      var targetIndex = index + 1;
      data.items.splice(targetIndex, 0, copyItem);
      this.onEditer(targetIndex);
    },
    onStartDragItem: function onStartDragItem(type) {
      this.draggingNewType = type || '';
    },
    onEndDragItem: function onEndDragItem() {
      this.draggingNewType = '';
    },
    /**
     * 验证新增Diy组件
     * @param type
     */
    onCheckAddItem: function onCheckAddItem(type) {
      var data = this.data;
      // 验证xx组件只能存在一个
      if (type === 'xxx') {
        var itemsTypes = data.items.map(function (item) {
          return item.type;
        });
        if ((0, _util.inArray)(type, itemsTypes)) {
          this.$message.warning('该组件最多存在一个');
          return false;
        }
      }

      // if(data.items.length>0){
      //   let isHasSingle = false
      //   for (let i = 0; i < data.items.length; i++) {
      //     if(type === 'tabList'){
      //       this.$message.warning('此组件为单页面组件，请先删除其他全部组件')
      //       isHasSingle = true
      //       return false
      //     }
      //   }
      //   if(isHasSingle){
      //     this.$message.warning('此页面目前为单页面组件，如需修改，请先删除单页面组件后在操作')
      //     return false
      //   }
      // }

      return true;
    },
    /**
     * 编辑当前选中的Diy元素
     * @param index
     */
    onEditer: function onEditer(index) {
      var data = this.data;
      // 记录当前选中元素的索引
      this.selectedIndex = index;
      // 当前选中的元素数据
      this.curItem = index === 'page' ? data.page : data.items[index];
    },
    /**
     * 删除diy元素
     * @param index
     */
    onDeleleItem: function onDeleleItem(index) {
      var items = this.data.items;
      items.splice(index, 1);
      this.selectedIndex = -1;
    },
    /**
     * 编辑器：重置颜色
     * @param holder
     * @param attribute
     * @param color
     */
    onEditorResetColor: function onEditorResetColor(holder, attribute, color) {
      holder[attribute] = color;
    },
    // 提交到后端api
    onFormSubmit: function onFormSubmit() {
      var _this4 = this;
      this.isLoading = true;
      var pageId = this.pageId,
        data = this.data,
        $message = this.$message;
      this.$refs.phone.getItemsHeight();
      Api.edit({
        pageId: pageId,
        form: data
      }).then(function (result) {
        // 显示成功
        $message.success(result.message, 1.5);
        // 跳转到列表页
        setTimeout(function () {
          _this4.$router.push('/content/page');
        }, 1200);
      }).finally(function () {
        setTimeout(function () {
          _this4.isLoading = false;
        }, 1500);
      });
    }
  }
};